<div class="flex flex-column gap-md">
  <ng-container *ngIf="message; else code">
    <p-message [severity]="message.severity" [text]="message.summary"></p-message>
  </ng-container>
  <ng-template #code>
    <div class="flex flex-column gap-sm align-items-center">
      <vnm-qr-code class="qr-container" [data]="codeUrl"></vnm-qr-code>
      <a
        *ngIf="appUrl"
        pButton
        class="p-button-secondary app-link"
        icon="fa fa-fw fa-external-link"
        iconPos="right"
        [attr.href]="appUrl | safeURL"
        [label]="'verified-credential.open-app' | translate"
      ></a>
    </div>
  </ng-template>
  <vnm-ably-channel-subscription
    [channel]="channel"
    (errorEvent)="onCredentialError($event)"
    (successEvent)="onCredentialIssued($event)"
  ></vnm-ably-channel-subscription>
</div>
